import React from 'react';
import DailyCustomerPortfolio from 'components/Tvendo/Sale/DataMaster/DailyCustomerPortfolio/List.js';

export default function () {
  return <DailyCustomerPortfolio />;
}
